export * from "./Bom2aPosCopyFrom";
